import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { ReceptionistLoginForm } from '@/pages/ReceptionistLogin/index.js';
import { Page404 } from '@/pages/Page404';
import { Acknowledgement } from '@/pages/Acknowledgement/Acknowledgement';
import { ReceptionistDashboard } from '@/pages/ReceptionistDashboard';
import { CallInformation } from '@/pages/CallInformation';
import { AppRoutes, UNBRANDED_DOMAINS } from 'src/enums/ERoutes';
import { ForgotPassword } from '@/pages/ForgotPassword/index.js';

import { Toaster } from 'react-hot-toast';

import ReactiveAccount from '@/pages/ReactivateAccount/ReactiveAccount.js';
import ShortURLRedirect from '@/pages/ShortURLRedirect/ShortURLRedirect.tsx';
import PaymentSuccess from '@/pages/PaymentSuccessful/PaymentSuccess.js';
import Intercom from '@intercom/messenger-js-sdk';
import { ResetPassword } from '@/pages/ResetPassword/index.js';
import WatermarkRemovalSuccess from '@/pages/WatermarkRemovalSuccess/WatermarkRemovalSuccess.js';
import UnbrandedReceptionist from '@/pages/UnbrandedReceptionist/UnbrandedReceptionist.tsx';
import UnbrandedRegistration from '@/pages/UnbrandedRegistration/UnbrandedRegistration.tsx';
import { PrivateResellerRoute } from './privateReseller.js';
import ResellerReceptionist from '@/pages/ResellerDashboard/ResellerReceptionist/ResellerReceptionist.js';
import ResellerBranding from '@/pages/ResellerDashboard/ResellerBranding/ResellerBranding.js';
import ResellerSubscription from '@/pages/ResellerDashboard/ResellerSubscription/ResellerSubscription.js';
import UserRegistrationPage from '@/pages/UserRegistration/UserRegistrationPage.js';
import ResellerPhoneNumbers from '@/pages/ResellerDashboard/ResellerPhoneNumbers/ResellerPhoneNumbers.js';
import ImportPhoneNumbers from '@/pages/ResellerDashboard/ImportPhoneNumbers/ImportPhoneNumbers.js';
import Blogs from '@/pages/Blogs/Blogs.tsx';
import BlogPage from '@/pages/BlogPage/BlogPage.tsx';
import IntegrationsPage from '@/pages/IntegrationsPage/IntegrationsPage.tsx';
import Integrations from '@/pages/Integrations/Integrations.tsx';
import ResellerEmbed from '@/pages/ResellerDashboard/ResellerEmbed/ResellerEmbed.tsx';
import PublicResellerRoute from './publicReseller.js';
import AffiliateProgramPage from '@/pages/AffiliateProgram/AffiliateProgram.tsx';
import ResellerQualificationForm from '@/pages/ResellerQualificationForm/ResellerQualificationForm.js';
import TestReceptionistPage from '@/pages/TestReceptionist/TestReceptionist.js';
import { useEffect } from 'react';
import { getLoggedInUser } from '@/store/account/selector';
import { useAppSelector } from '@/store/hooks/useAppSelector';
import TrialReceptionist from '@/pages/ResellerDashboard/TrialReceptionist/TrialReceptionist.js';
import { ResellerForgotPassword } from '@/pages/ResellerDashboard/ResellerForgotPassword/index.js';
import { ResellerResetPassword } from '@/pages/ResellerDashboard/ResellerResetPassword/index.js';
import { getResellerData } from '@/store/reseller/selector.js';
import OAuthCallBackPage from '@/pages/OAuth/callback.js';
import ResellerAcademy from '../pages/ResellerAcademy/ResellerAcademy.jsx';
import ChapterDetail from '@/pages/ResellerAcademy/ChapterDetail/ChapterDetail.js';
import VideoPlayer from '@/pages/ResellerAcademy/VideoPlayer/VideoPlayer.js';
import PdfViewer from '@/pages/ResellerAcademy/PDFViewer/PdfViewer.js';
import TutorialViewer from '@/pages/ResellerAcademy/TutorialViewer/TutorialViewer.js';
import ForwardingSetupInstructions from '@/pages/GettingStarted/ForwardingSetupInstructions/index.js';
import { POSTHOG_FEATURE_FLAGS } from 'src/constants.js';
import { useDispatch } from 'react-redux';
import { setFeatureFlag } from '@/store/app/slice.js';
import { NoviDashboard } from '@/pages/Novi/pages/Dashboard/NoviDashboard.js';
import { WhitelabelCampaignLogin } from '@/pages/Novi/pages/Dashboard/Campagins/CampaignLogin/WhitelabelCampaignLogin.js';
import WhitelabelCampaignDashboard from '@/pages/Novi/pages/Dashboard/Campagins/CampaignDashboard/WhitelabelCampaignDashboard.js';
import WhitelabelCampaignPublicRoute from '@/pages/Novi/routes/whitelabelCampaignPublic.js';
import WhitelabelCampaignPrivateRoute from '@/pages/Novi/routes/whitelabelCampaignPrivate.js';
import posthog from 'posthog-js';
import ResellerPlansCreation from '@/pages/ResellerDashboard/ResellerPlansCreation/ResellerPlansCreation.js';
import ResellerPlanManagement from '@/pages/ResellerDashboard/ResellerPlanManagement/ResellerPlanManagement.js';
import ResellerEmail from '@/pages/ResellerDashboard/ResellerEmail/ResellerEmail.js';
// import ResellerDemo from '@/pages/ResellerDemo/ResellerDemo.js';
import { useFeatureFlag } from 'src/Hooks/useFeatureFlag.js';
import { FeatureFlag } from 'src/enums/EFeatureFlags.js';
import ResellerCustomDomain from '@/pages/ResellerDashboard/ResellerCustomDomain/ResellerCustomDomain.js';
import ConditionalResellerRoutes from './ConditionalResellerRoute.js';
import ResellerContactSupport from '@/pages/ResellerDashboard/ResellerContactSupport/ResellerContactSupport.js';
import ResellerOnboarding from '@/pages/ResellerDashboard/ResellerOnboarding/ResellerOnboarding.js';
import PaymentSuccessForReseller from '@/pages/ThankyouReseller/PaymentSuccess.js';
import ResellerWebhooks from '@/pages/ResellerDashboard/ResellerWebhooks/ResellerWebhooks.js';
import ResellerCustomerSupport from '@/pages/ResellerDashboard/ResellerIntercomSupport/ResellerIntercomSupport.js';
import UserPrivateRoute from './UserPrivateRoute.js';
import { UserDashboard } from '@/pages/UserDashboard/index.js';
import UserPublicRoute from './UserPublicRoute.js';
import InboundAgentRoute from './InboundAgentRoute.js';
import OutboundAgentRoute from './OutboundAgentRoute.js';
import ManageCredits from '@/pages/ResellerDashboard/ResellerManageCredits/ManageCredits.js';
import AdminDashboard from '@/pages/AdminDashboard/AdminDashboard.js';
import ContactSales from '@/pages/ContactSales/ContactSales';
import ResellerAdvanceSettings from '@/pages/ResellerDashboard/ResellerAdvanceSettings/ResellerAdvanceSettings.js';
import ShareDemo from '@/pages/ShareDemo/ShareDemo';
import AffiliateRegisterPage from '@/pages/AffiliateDemo/AffiliateDemoRegisterPage.js';

const AppRouter: React.FC = () => {
	const domain = window.location.hostname;
	const location = window.location;

	const currentReseller = useAppSelector(getResellerData);
	const loggedInUser = useAppSelector(getLoggedInUser);
	const dispatch = useDispatch();

	const variantKey =
		posthog.getFeatureFlag(POSTHOG_FEATURE_FLAGS.ONBOARDING_REGISTRATION_REVAMP.key) || 'new';

	// Check if the feature flag is enabled
	const isCustomDomainEnabled = useFeatureFlag(FeatureFlag.CUSTOM_DOMAIN_FLAG);

	useEffect(() => {
		if (variantKey) {
			dispatch(
				setFeatureFlag({
					key: 'ONBOARDING_REGISTRATION_REVAMP',
					variant: variantKey,
				}),
			);
		}
	}, [variantKey]);

	useEffect(() => {
		const isResellerDashboard = location.pathname.includes(AppRoutes.RESELLER_PORTAL);

		if (isResellerDashboard) {
			if (!currentReseller?.emailAddress) {
				return;
			} // return early if the reseller data is not loaded yet

			// Only show Intercom if domain is branded AND reseller is branded
			if (
				UNBRANDED_DOMAINS.some((unbrandedDomain) => domain.includes(unbrandedDomain)) ||
				currentReseller?.permanently_unbranded ||
				currentReseller?.branded
			) {
				// Hide/Remove Intercom
				window.Intercom?.('shutdown');
			} else {
				Intercom({
					app_id: import.meta.env.VITE_APP_INTERCOM_BOT_APP_ID,
					vertical_padding: 50,
				});
			}
		} else {
			if (!loggedInUser?.id) {
				return;
			} // return early if the user data is not loaded yet

			// Only show Intercom if domain is branded AND reseller is branded
			if (currentReseller?.amplifyAppId && !currentReseller?.intercom_app_id) {
				// Hide/Remove Intercom
				window.Intercom?.('shutdown');
			} else {
				if (loggedInUser?.resellerId) {
					if (currentReseller?.intercom_app_id) {
						Intercom({
							app_id: currentReseller?.intercom_app_id,
							vertical_padding: 50,
						});
					} else {
						window.Intercom?.('shutdown');
					}
				} else {
					Intercom({
						app_id: import.meta.env.VITE_APP_INTERCOM_BOT_APP_ID,
						vertical_padding: 50,
					});
				}
			}
		}
	}, [
		loggedInUser?.id,
		loggedInUser?.resellerId,
		currentReseller?.branded,
		currentReseller?.intercom_app_id,
		currentReseller?.permanently_unbranded,
	]);

	return (
		<Router>
			<Routes>
				<Route element={<UserPublicRoute />}>
					<Route element={<ReceptionistLoginForm />} path={AppRoutes.RECEPTIONIST_LOGIN} />
					<Route element={<ForgotPassword />} path={AppRoutes.FORGOT_PASSWORD} />
					<Route element={<UnbrandedRegistration />} path={AppRoutes.UNBRANDED_REGISTER} />
					<Route element={<UnbrandedRegistration />} path={AppRoutes.GENERIC_DOMAIN_REGISTER} />
					<Route
						element={<UnbrandedRegistration test={true} />}
						path={AppRoutes.UNBRANDED_CLIENT_TRIAL}
					/>
					<Route element={<ResetPassword />} path={AppRoutes.RESET_PASSWORD} />
					<Route
						element={
							<>
								<UserRegistrationPage userId={loggedInUser?.id} agentType={'Inbound'} />
								<Toaster />
							</>
						}
						path={AppRoutes.REGISTER}
					/>
					<Route element={<OAuthCallBackPage />} path={AppRoutes.OAUTH_CALLBACK} />
					<Route
						element={
							<>
								<AffiliateRegisterPage />
								<Toaster />
							</>
						}
						path={AppRoutes.AFFILIATE_DEMO}
					/>
				</Route>

				<Route element={<UserPrivateRoute />}>
					<Route
						element={
							UNBRANDED_DOMAINS.some((unbrandedDomain) => domain.includes(unbrandedDomain)) ? (
								<Page404 />
							) : (
								<UserDashboard
									debrand={
										UNBRANDED_DOMAINS.some((unbrandedDomain) => domain.includes(unbrandedDomain)) ||
										loggedInUser?.resellerClient ||
										false
									}
								/>
							)
						}
						path={AppRoutes.DASHBOARD}
					/>
					<Route
						element={<UserDashboard debrand={!!loggedInUser?.resellerClient} />}
						path={AppRoutes.UNBRANDED_DASHBOARD}
					/>

					{/* Payment Success Routes */}
					<Route element={<PaymentSuccess />} path={AppRoutes.PAYMENT_SUCCESS} />
					<Route element={<WatermarkRemovalSuccess />} path={AppRoutes.WATERMARK_REMOVAL_SUCCESS} />
					<Route
						element={<PaymentSuccess debrand={true} />}
						path={AppRoutes.RESELLER_CLIENT_SUCCESS}
					/>

					{/* Inbound Agent Routes */}
					<Route element={<InboundAgentRoute />}>
						<Route
							element={<ReceptionistDashboard debrand={!!loggedInUser?.resellerClient} />}
							path={AppRoutes.INBOUND_AGENT_PORTAL}
						/>
						<Route element={<UnbrandedReceptionist />} path={AppRoutes.UNBRANDED_RECEPTIONIST} />
						<Route
							element={<ReceptionistDashboard debrand={!!loggedInUser?.resellerClient} />}
							path={AppRoutes.UNBRANDED_INBOUND_AGENT_PORTAL}
						/>
						<Route
							element={<ForwardingSetupInstructions />}
							path={AppRoutes.FORWARDING_SETUP_INSTRUCTIONS}
						/>
					</Route>

					{/* Outbound Agent Routes */}
					<Route element={<OutboundAgentRoute />}>
						<Route element={<NoviDashboard />} path={AppRoutes.OUTBOUND_AGENT_PORTAL} />
					</Route>
				</Route>

				{/* Reseller Public/Authenticated Routes */}
				<Route element={<PublicResellerRoute />}>
					<Route path={AppRoutes.RESELLER_SURVEY_FORM} element={<ResellerQualificationForm />} />
					<Route path={AppRoutes.CUSTOM_OFFER_RESELLER} element={<ResellerQualificationForm />} />
					<Route element={<ResellerForgotPassword />} path={AppRoutes.RESELLER_FORGOT_PASSWORD} />
					<Route element={<ResellerResetPassword />} path={AppRoutes.RESELLER_RESET_PASSWORD} />
					<Route path={AppRoutes.AFFILIATE_PROGRAM} element={<AffiliateProgramPage />} />
					<Route path={AppRoutes.TEST_RECEPTIONIST} element={<TestReceptionistPage />} />
					<Route path={AppRoutes.THANK_YOU_RESELLER} element={<PaymentSuccessForReseller />} />
				</Route>

				{/* Reseller Private/Authenticated Routes */}
				<Route element={<PrivateResellerRoute />}>
					<Route element={<ResellerReceptionist />} path={AppRoutes.RESELLER_PORTAL} />
					<Route element={<ResellerOnboarding />} path={AppRoutes.RESELLER_ONBOARDING} />
					<Route element={<ResellerPlansCreation />} path={AppRoutes.RESELLER_PLAN_CREATION} />
					<Route element={<ResellerPlanManagement />} path={AppRoutes.RESELLER_PLAN_VIEW} />
					<Route element={<ResellerEmbed />} path={AppRoutes.RESELLER_EMBED} />
					{isCustomDomainEnabled && (
						<Route element={<ResellerCustomDomain />} path={AppRoutes.RESELLER_CUSTOM_DOMAIN} />
					)}
					<Route element={<ResellerBranding />} path={AppRoutes.RESELLER_BRANDING} />
					<Route element={<ResellerCustomerSupport />} path={AppRoutes.RESELLER_INTERCOM_SUPPORT} />
					<Route element={<TrialReceptionist />} path={AppRoutes.TRIAL_RECEPTIONIST} />
					<Route element={<ResellerSubscription />} path={AppRoutes.RESELLER_SUBSCRIPTION} />
					<Route element={<ResellerPhoneNumbers />} path={AppRoutes.RESELLER_PHONE_NUMBERS} />
					<Route element={<ResellerEmail />} path={AppRoutes.RESELLER_EMAIL_CONFIG} />
					<Route element={<ResellerContactSupport />} path={AppRoutes.RESELLER_CONTACT_SUPPORT} />
					<Route element={<ImportPhoneNumbers />} path={AppRoutes.RESELLER_IMPORT_NUMBER} />
					<Route element={<ResellerWebhooks />} path={AppRoutes.RESELLER_WEBHOOKS} />
					<Route
						element={<PaymentSuccess reseller={true} />}
						path={AppRoutes.PAYMENT_SUCCESS_RESELLER}
					/>
					<Route element={<ResellerAcademy />} path={AppRoutes.RESELLER_ACADEMY} />
					<Route element={<ChapterDetail />} path={AppRoutes.RESELLER_ACADEMY_CHAPTER} />
					<Route element={<VideoPlayer />} path={AppRoutes.RESELLER_ACADEMY_VIDEO} />
					<Route element={<PdfViewer />} path={AppRoutes.RESELLER_ACADEMY_PDF} />
					<Route element={<TutorialViewer />} path={AppRoutes.RESELLER_ACADEMY_TUTORIAL} />
					<Route element={<ManageCredits />} path={AppRoutes.RESELLER_MANAGE_CREDITS} />
					<Route
						element={<ResellerAdvanceSettings />}
						path={AppRoutes.RESELLER_ADVANCED_SETTINGS}
					/>
					<Route element={<ConditionalResellerRoutes />}>
						<Route
							element={<NoviDashboard resellerView={true} />}
							path={AppRoutes.RESELLER_OUTBOUND}
						/>
					</Route>
				</Route>

				<Route element={<ContactSales />} path={AppRoutes.CONTACT_SALES} />
				<Route element={<CallInformation />} path={AppRoutes.CALL_INFORMATION} />
				<Route element={<ShortURLRedirect />} path={AppRoutes.SHORT_URL_REDIRECT} />
				<Route element={<Acknowledgement />} path={AppRoutes.ACKNOWLEDGEMENT} />
				<Route element={<Page404 />} path={AppRoutes.NOT_FOUND} />
				<Route element={<ReactiveAccount />} path={AppRoutes.REACTIVATE_ACCOUNT} />

				{/* Blog routes */}
				<Route element={<Blogs />} path={AppRoutes.BLOGS} />
				<Route element={<BlogPage />} path={AppRoutes.BLOG_PAGE} />

				{/* Product Lead Growth Routes */}
				<Route element={<ShareDemo />} path={AppRoutes.SHAREABLE_DEMO_PAGE} />

				{/* Integration Routes */}
				<Route element={<Integrations />} path={AppRoutes.INTEGRATIONS} />
				<Route element={<IntegrationsPage />} path={AppRoutes.INTEGRATIONS_PAGE} />

				<Route element={<WhitelabelCampaignPublicRoute />}>
					<Route
						element={<WhitelabelCampaignLogin />}
						path={AppRoutes.WHITE_LABEL_CAMPAIGN_LOGIN}
					/>
					<Route
						element={<UnbrandedRegistration isCampaign={true} isStandaloneCampaign={true} />}
						path={AppRoutes.WHITE_LABEL_CAMPAIGN_REGISTER}
					/>
				</Route>
				<Route element={<WhitelabelCampaignPrivateRoute />}>
					<Route
						element={<WhitelabelCampaignDashboard />}
						path={AppRoutes.WHITE_LABEL_CAMPAIGN_DASHBOARD}
					/>
				</Route>

				<Route path="/internal-admin" element={<AdminDashboard />} />
			</Routes>
		</Router>
	);
};

export default AppRouter;
